import { Option, TranslationFunction } from '@/types';

export const columns = ($t: TranslationFunction): Option[] => [
  {
    label: $t('firstNameUpperCase'),
    value: 'firstName'
  },
  {
    label: $t('lastNameUpperCase'),
    value: 'lastName'
  },
  {
    label: $t('emailUpperCase'),
    value: 'email'
  },
  {
    label: $t('pharmacyNameUpperCase'),
    value: 'pharmacyId'
  },
  {
    label: $t('roleUpperCase'),
    value: 'role'
  },
  {
    label: $t('userIdUpperCase'),
    value: 'id'
  }
];
